export default function PicturesSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 716.86 89.36"
      className="w-64 max-h-7 2xl:max-h-8"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="svg-text"
            fill="#131414"
            d="M0,34.89V23.1H9.43V13.57l14.74-3.24V23.1H36.06V34.89H24.17V56.11c0,2.17.69,2.75,2.85,2.75h9.63V71.24H23.58c-10.32,0-14.15-3.34-14.15-13V34.89Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M41.85,71.24V22.12H55.41l1,6.19h1c3.34-4.22,8-7.66,15.43-7.66,7.86,0,13.07,3.73,16.8,8.74h1c3.83-5,9.63-8.74,18.27-8.74,12.78,0,19.85,8.74,19.85,20.73V71.24H114V45.6c0-8.15-2.26-12.18-9.62-12.18s-11.7,5.21-11.7,12.48V71.24H77.91V45.6c0-8.15-2.26-12.18-9.63-12.18s-11.69,5.4-11.69,12.67V71.24Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M134.89,71.24V22.12h13.56l1,6.19h1A18.83,18.83,0,0,1,166,20.84c12.77,0,20,8.75,20,20.73V45.7H171.34V43.44c0-6.58-3.25-10-9.83-10-7.37,0-11.89,5.4-11.89,12.67V71.24Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M186.44,22.12h15.62l8.35,37.14h1L222.1,22.12h18.27l10.71,37.14h1l8.35-37.14H276L262,71.24H241.55L231.24,36.37,220.92,71.24H200.49Z"
          />
          <circle
            className="svg-dot"
            fill="#fc473c"
            cx="283.47"
            cy="61.5"
            r="11.34"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M300.9,89.36V22.56h13.56l1,6h1c3.34-4.23,9.43-7.47,17.58-7.47,14.25,0,25.45,10.51,25.45,26s-11.2,26-25.45,26c-8.15,0-14.05-3.24-17.39-7.47h-1V89.36Zm29-28.59c9.33,0,14.54-5,14.54-13.65s-5.21-13.66-14.54-13.66-14.54,5.6-14.54,13.66S320.55,60.77,329.89,60.77Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M379.4,71.68H364.66V22.56H379.4ZM381,9a9,9,0,1,1-9-9A9,9,0,0,1,381,9Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M414,21.08c16,0,27.8,9.43,29,23H427.83c-1-6.68-6-10.61-13.85-10.61-9.14,0-14.25,5-14.25,13.66S404.84,60.77,414,60.77c8.25,0,13.36-4.12,14.15-11h15.13c-1,13.85-12.87,23.38-29.28,23.38-17.29,0-29.38-10.61-29.38-26S396.69,21.08,414,21.08Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M444.24,35.33V23.54h9.43V14l14.74-3.24V23.54h11.88V35.33H468.41V56.55c0,2.16.68,2.75,2.85,2.75h9.62V71.68H467.82c-10.32,0-14.15-3.34-14.15-13V35.33Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M540,22.56V71.68H526.47l-1-6.19h-1a20.81,20.81,0,0,1-16.6,7.66c-13.26,0-22.1-7.66-22.1-23.77V22.56h14.73V47.21c0,9.14,2.65,13.37,11.3,13.37,8,0,13.46-4.62,13.46-13.46V22.56Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M546.51,71.68V22.56h13.56l1,6.18h1a18.83,18.83,0,0,1,15.62-7.46c12.77,0,20,8.74,20,20.73v4.12H583V43.87c0-6.58-3.24-10-9.83-10-7.36,0-11.88,5.41-11.88,12.68V71.68Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M630.8,21.08c18.08,0,30.16,11.3,28.69,29.38H616.75C617.83,56.84,623.24,61,630.9,61c6.78,0,11.3-2.75,13.26-7.27h15.62C657,65.39,646,73.15,630.9,73.15c-17.39,0-29.28-10.51-29.28-26S613.61,21.08,630.8,21.08Zm12.87,20c-1-4.92-5.89-8-12.67-8s-12.87,3-13.85,8Z"
          />
          <path
            className="svg-text"
            fill="#131414"
            d="M678.35,52.72C679.73,59,684,62,691.81,62c7.27,0,9.92-1.67,9.92-4.32,0-2.16-1.18-3.64-5.4-4.32l-15-2.56c-10.12-1.67-16.41-6.19-16.41-14.15,0-10,10.32-15.52,24.56-15.52,15.23,0,25.15,7.27,26.82,19.26H701.44c-1.28-5.41-4.91-8.06-12-8.06S680,33.76,680,36.21c0,2,1.08,3,4.91,3.73l15.23,2.66c10.71,1.86,16.7,6.68,16.7,14.64,0,10.51-10.12,15.91-25.05,15.91-16.11,0-26.23-7.37-28.29-20.43Z"
          />
        </g>
      </g>
    </svg>
  );
}
